module.exports = __webpack_public_path__ + "img/category_line.04f539e2.svg";